<div class="card mb-3">
    <div class="card-body pb-0">
        <div class="card-title fw-bold">
            <h5>{{ 'utilities_photos' | translate }}</h5>
        </div>
    </div>

    @if (images$ | async; as images) {
        @if (images.length === 0) {
            <div class="alert alert-info">
                {{ 'utilities_NO_PHOTOS_OF_ITEM' | translate }}
            </div>
        } @else {
            <ngb-carousel
                [showNavigationIndicators]="false"
                [interval]="0"
                (slide)="onSlideChange($event)">
                @for (image of images; track image; let index = $index) {
                    <ng-template ngbSlide [id]="'slide-' + index">
                        <div class="image-container">
                            <img [src]="image.objectUrl" alt="" />
                        </div>
                    </ng-template>
                }
            </ngb-carousel>

            <div class="card-body">
                <ul class="list-group list-group-flush description-list">
                    <li class="list-group-item">
                        <span>{{ 'utilities_DATE' | translate }}</span>
                        <span>{{ images[currentIndex].timestamp | appdatetime }}</span>
                    </li>
                </ul>

                @if (images.length > 1) {
                    <div id="miniature-gallery">
                        @for (image of images; track image; let i = $index) {
                            <button
                                class="btn btn-text-primary"
                                [id]="'miniature-' + i"
                                [ngClass]="{selectedImg: i === currentIndex}"
                                (click)="carouselSelect(i)">
                                <img alt="" [src]="image.objectUrl" />
                            </button>
                        }
                    </div>
                }
            </div>
        }
    } @else {
        <app-load />
    }
</div>
